import SecurityAuthPage from "./security-auth-page";

export default SecurityAuthPage;
